import { EngagementStep } from '../../../../types/advise';

export const ENGAGEMENT_TABS = [
  { key: 'discovery', label: 'Discovery', step: 'discovery' },
  { key: 'features', label: 'Functionality Matrix', step: 'functionality_matrix' },
  { key: 'quotes', label: 'Official Quotes', step: 'quotes_pricing' },
  { key: 'pricing', label: 'Pricing', step: 'quotes_pricing' },
  { key: 'roi', label: 'ROI Analysis', step: 'roi_analysis' },
  { key: 'data_room', label: 'Data Room', step: 'artifacts' },
  { key: 'action_plan', label: 'Action Plan', step: null }
] as const;

export type EngagementTab = (typeof ENGAGEMENT_TABS)[number];
export type EngagementTabKey = EngagementTab['key'];

// Matches the steps whose data upstack_api's Engagements::Configuration::STEP_FIELDS withholds from the share link.
const STEP_REPORT_SECTIONS: Record<string, string[]> = {
  quotes_pricing: ['official_quotes', 'pricing'],
  roi_analysis: ['roi_analysis']
};

// No saved configuration, or a step the engagement's template lacks, means the step is on.
export const isStepEnabled = (steps: EngagementStep[] | undefined, stepKey: string | null): boolean =>
  !stepKey || !steps?.some((step) => step.key === stepKey && !step.enabled);

export const visibleTabs = (steps: EngagementStep[] | undefined): EngagementTab[] =>
  ENGAGEMENT_TABS.filter((tab) => isStepEnabled(steps, tab.step));

export const withheldReportSections = (steps: EngagementStep[] | undefined): Record<string, boolean> =>
  Object.fromEntries(
    (steps || [])
      .filter((step) => !step.enabled)
      .flatMap((step) => STEP_REPORT_SECTIONS[step.key] || [])
      .map((section) => [section, false])
  );
